import React, { useState, useEffect } from "react";
import Phones from "google-libphonenumber";
import Countries from "../../services/countries.service";
import Settings from "../../services/settings.service";
// import CountrySelect from '../shared/country-select-v2.component';
import FieldValidity from "../../services/fieldValidity.service";
import ReCAPTCHA from "react-google-recaptcha";
import Translation from "../../services/translation.service";
import Storage from "../../services/storage.service";
import CountrySelectModal from '../shared/country-select-modal.component';

// This Component is responsible for below reports:
// 1. Fraud/Spam Calls
// 2. Spam SMS > Report by Number

export default function ProtectionChannelSpamCalls({
  reportSpamCall = () => {},
  showMessage = false,
  subTypeHasLandlineSubstring = false,
  reportSubType,
}) {
  let phoneUtil = Phones.PhoneNumberUtil.getInstance();
  let prefix = "scr_protection_channel";
  const [formValid, setFormValid] = useState(false);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  let error_prefix = "scr_protection_channel_err_";

  const isLandlineNumber = reportSubType?.FraudGenericType === "LandLine";
  const isLocalSmsNumber = reportSubType?.FraudGenericType === "SMS";
  const isLocalCallNumber = reportSubType?.FraudGenericType === "Call";

  const getStorageValue = (key) => {
    let business = JSON.parse(Storage.get("business", true));
    let poValue = business["fraud_validation"]
      ? business["fraud_validation"]
      : "";
    if (poValue) {
      return poValue[key] ? poValue[key] : "";
    } else {
      return "";
    }
  };

  let data_payload = JSON.parse(Storage.get("PrePayload"));
  const [phoneCode, setPhoneCode] = useState({
    value: data_payload?.iso_value ? data_payload?.iso_value : (isLandlineNumber || isLocalSmsNumber || isLocalCallNumber) ? "SA" : "AF",
    iso: data_payload?.iso_code ? data_payload?.iso_code : (isLandlineNumber || isLocalSmsNumber || isLocalCallNumber) ? 966 : 93, 
    valid: true,
    touched: false,
  });

  const [phone, setPhone] = useState({
    value: "",
    validations: {
      required: true,
      contactNumber: true,
    },
    valid: false,
    touched: false,
    dependency: "selected_country_contact",
    error: "",
  });

  const [senderMessage, setSenderMessage] = useState({
    value: "",
    valid: false,
    touched: false,
    validations: {
      requiredObject: true,
      minLength: getStorageValue("fraud_sms_content_char_limit_min"),
      maxLengthObj: getStorageValue("fraud_sms_content_char_limit_max"),
    },
    error: "",
  });

  useEffect(() => {
    prefilledData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (phone.value) {
      updateContactField(phone.value);
    }
  }, [subTypeHasLandlineSubstring, reportSubType]); // eslint-disable-line react-hooks/exhaustive-deps

  const prefilledData = () => {
    setCaptchaChecked(false);
    if (data_payload && data_payload?.ReportedMSISDNNo) {
      updateContactField(data_payload?.ReportedMSISDNNo);
    }
    if (data_payload && data_payload?.Notes) {
      handleMessageChange(data_payload?.Notes);
    }
  };
  const handleCountryCode = (country_select, country_iso) => {
    setPhoneCode({
      ...phoneCode,
      value: country_select,
      touched: true,
      iso: country_iso.substring(1),
    });
  
    // Clear the phone input when country changes (for non-local numbers)
    if (!(isLandlineNumber || isLocalSmsNumber || isLocalCallNumber)) {
      setPhone({
        ...phone,
        value: "",
        valid: false,
        touched: false,
        error: "",
      });
      setFormValid(false);
      return; // Exit early since we've cleared the phone field
    }
  
    // Only validate existing phone number if it's a local number type
    if (phone?.value?.length) {
      let validcontact = "";
      let value = phone?.value;
      if (value.length > 6 && Settings.formats.phonenumber.test(value)) {
        let country = null;
        let dependency = country_select;
        country = Countries.Countries[dependency];
        if (country && country.ISO_2Code) {
          let number = phoneUtil.parse(value, country.ISO_2Code);
          validcontact = phoneUtil.isValidNumber(number);
        } else {
          validcontact = Settings.formats.phonenumber.test(value);
        }
      } else {
        validcontact = false;
      }
      let errorMsg = "";
      if (!validcontact) {
        errorMsg = "error_number_invalid";
      } else {
        errorMsg = "";
      }
      setPhone({
        ...phone,
        valid: validcontact,
        touched: true,
        error: errorMsg,
      });
    }
    
    if (phone?.valid) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const updateContactField = (data) => {
    let validcontact = "";

    if (data.length > 6 && Settings.formats.phonenumber.test(data)) {
      let country = null;
      let dependency = phoneCode?.value;
      country = Countries.Countries[dependency];
      if (isLandlineNumber && country && country.ISO_2Code) {
        let number = phoneUtil.parse(data, country.ISO_2Code);
        const numberString =
          number.getCountryCode().toString() +
          number.getNationalNumber().toString();
        validcontact = Settings.formats.ksaLandline.test(numberString);
      } else if (country && country.ISO_2Code) {
        let number = phoneUtil.parse(data, country.ISO_2Code);
        validcontact = phoneUtil.isValidNumber(number);
      } else {
        validcontact = Settings.formats.phonenumber.test(data);
      }
    } else {
      validcontact = false;
    }

    let errorMsg = "";
    if (!validcontact && !data) {
      errorMsg = Translation.keys[error_prefix + "error_required_message"];
    } else if (!validcontact && data) {
      errorMsg = Translation.keys[error_prefix + "error_number_invalid"];
    } else {
      errorMsg = "";
    }
    setPhone({
      ...phone,
      value: data,
      data_submition: true,
      valid: validcontact,
      touched: true,
      error: errorMsg,
    });
    if (validcontact) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const updateCaptcha = (value) => {
    if (value) {
      setCaptchaChecked(true);
    } else {
      setCaptchaChecked(false);
    }
  };

  const handleMessageChange = (data) => {
    // if (e.target.name === "senderMessage") {
    let msgValid = FieldValidity.checkFieldValidity(
      data,
      senderMessage.validations
    );
    let errorMsg = "";
    if (!msgValid?.valid && !data) {
      errorMsg = Translation.keys[error_prefix + "error_required_message"];
    } else if (!msgValid?.valid && msgValid?.type === "length" && data) {
      errorMsg =
        Translation.keys[error_prefix + "fraud_sms_content_char_limit_min"];
      // errorMsg = "The field must have at least 10 characters";
    } else if (!msgValid?.valid && msgValid?.type === "maxLength" && data) {
      errorMsg =
        Translation.keys[error_prefix + "fraud_sms_content_char_limit_max"];
      // errorMsg = "The field must have maximum 200 characters";
    } else {
      errorMsg = "";
    }
    setSenderMessage({
      ...senderMessage,
      value: data,
      valid: msgValid?.valid,
      data_submition: true,
      touched: true,
      error: errorMsg,
    });
    if (msgValid?.valid) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
    // }
  };
  const handleSubmit = () => {
    if (showMessage ? senderMessage?.valid : true && phone?.valid) {
      let payload = {
        senderMessage: senderMessage?.value,
        number: phoneCode?.iso + phone?.value,
        ReportedMSISDNNo: phone?.value,
        iso_code: phoneCode?.iso,
        iso_value: phoneCode?.value,
      };
      reportSpamCall(formValid, payload);
    }
  };

  const phoneValid = phone?.valid;
  const senderMessageValid = senderMessage?.valid;

  const isButtonDisabled = React.useMemo(() => {
    if (showMessage) {
      return (
        !captchaChecked || !phoneValid || !formValid || !senderMessageValid
      );
    }
    return !captchaChecked || !phoneValid || !formValid || !reportSubType;
  }, [
    // eslint-disable-line react-hooks/exhaustive-deps
    captchaChecked,
    showMessage,
    phoneValid,
    formValid,
    senderMessageValid,
    reportSubType,
  ]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter' && !isButtonDisabled) {
        // Don't submit if Enter is pressed in textarea
        if (event.target.tagName !== 'TEXTAREA') {
          handleSubmit();
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [isButtonDisabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="field-container">
        <label>{Translation.keys[prefix + "_contact_number"]}</label>
        <div className="storefront-two-fields">
          <div className="country-select-container">
            {(isLandlineNumber || isLocalSmsNumber || isLocalCallNumber) && (
              <CountrySelectModal
                form_id={"country_contact_user"}
                field_name="country_select"
                defaultCountry={"SA"}
                disabled
                isCustom={true}
              />
            )}

            {!(isLandlineNumber || isLocalSmsNumber || isLocalCallNumber) && (
              <CountrySelectModal
              form_id={"country_contact_user"}
                defaultCountry={phoneCode?.value}
                field_name="country_select"
                updateFieled={handleCountryCode}
                countrytoSkip="SA"
                isCustom={true}
              />
            )}
          </div>
          <input
            type="tel"
            className={
              "storefront-search-input " +
              (!phone.touched || (phone.touched && phone.valid)
                ? "valid"
                : "invalid") +
              (phone.value ? " filled" : "")
            }
            name="contact_number"
            id="contact_number"
            value={phone.value}
            placeholder={Translation.keys[prefix + "_contact_number"]}
            onChange={(event) => {
              if (FieldValidity.inputDigits(event, 10)) {
                updateContactField(event?.target?.value, "form", "phone");
              }
            }}
          />
        </div>
      </div>
      {showMessage ? (
        <>
          <div className="field-container">
            <label>{Translation.keys[prefix + "_enter_sms_content"]}</label>
            <textarea
              className={
                "storefront-search-input " +
                (!senderMessage.touched ||
                (senderMessage.touched && senderMessage.valid)
                  ? "valid"
                  : "invalid") +
                (senderMessage.value ? " filled" : "")
              }
              placeholder={Translation.keys[prefix + "_enter_sms_content_placeholder"]}
              name="senderMessage"
              type="text"
              rows={5}
              autoComplete="off"
              value={senderMessage?.value}
              onChange={(e) => handleMessageChange(e?.target?.value)}
              maxLength={getStorageValue("fraud_sms_content_char_limit_max")}
            />
            {!senderMessage.valid && senderMessage.touched && senderMessage.error ? (
              <span className="error-msg">{senderMessage?.error}</span>
            ) : null}
          </div>
        </>
      ) : null}
      <div className="field-container">
        <span>{Translation.keys[prefix + "_please_check_box"]}</span>
        <ReCAPTCHA
          sitekey={Settings.get("google_recaptcha_site_key")}
          onChange={updateCaptcha}
          hl={Translation.getCurrentLanguage() === "ar" ? "ar" : "en"}
        />
      </div>
      <button
        className="common-button"
        disabled={isButtonDisabled}
        onClick={() => {
          handleSubmit();
        }}
      >
        {Translation.keys[prefix + "_submit"]}
      </button>
    </>
  );
}
